export const capitalize = (value: string) => {
  if (!value) return null;
  return value.slice(0, 1).toUpperCase() + value.slice(1).toLowerCase();
};
